import { LaboratoryRequestIndicatorDto } from "../../laboratory/laboratory-request-indicator.dto";
import { LaboratoryWaterSampleDto } from "../../laboratory/laboratory-water-sample.dto";
import { RequestWaterSamplingAddress } from "./request-water-sampling-address";
import { RequestWaterSamplingContact } from "./request-water-sampling-contact";

export class RequestWaterSamplingAct {
    requestWaterSamplingActId: number;
    requestId: number;
    laboratoryExaminationObjectId: number;
    laboratoryExaminationObjectDescription: string;
    manufactureDate: Date;
    supplier: string;
    partNumber: string;
    laboratoryMaterialSourceId: number;
    laboratoryMaterialSourceDescription: string;
    laboratorySamplingPointId: number;
    laboratorySamplingPointDescription: string;
    laboratoryExaminationTypeId: number;
    laboratoryExaminationTargetId: number;
    laboratoryExaminationTargetDescription: string;
    laboratoryCertificateRequiringId: number;
    laboratoryResultDeliveryTypeId: number;
    laboratoryRecommendationId: number;
    approved: boolean;
    laboratoryAnalysisAgreed: string;
	sampleDescription: string;
	customerSampleName: string;
	laboratorySamplingPerformerId: number;
	laboratorySamplingPerformerName: string;
	laboratorySamplingPerformerDateTimeStart: Date;
	laboratorySamplingPerformerDateTimeEnd: Date;
	laboratorySamplingPerformerDescription: string;
	laboratorySampleDeliveryPerformerId: number;
	laboratorySampleDeliveryPerformerName: string;
	laboratorySampleDeliveryPerformerDateTime: Date;
	laboratorySampleDeliveryPerformerDescription: string;
	laboratorySampleLeftoverActionId: number;
	laboratorySampleLeftoverActionDescription: string;
	laboratorySampleContainerVisualDamageId: number;
	laboratorySampleContainerVisualDamageDescription: string;
	laboratorySampleContainerRequirementId: number;
	laboratorySampleContainerRequirementDescription: string;
	laboratoryDeliveryTimeRequirementId: number;
	laboratoryDeliveryTimeRequirementDescription: string;
	laboratorySampleContainerTypeId: number;
	laboratorySamplePreserveId: number;
	laboratorySamplePreserveDescription: string;
	laboratorySpecialMarkId: number;
	laboratorySpecialMarkDescription: string;
	laboratoryWaterSamplingMethodId: number;
	laboratoryWaterSamplingMethodDescription: string;
	waterTapDesinfection: boolean;
	waterTapPreRinsing: number;
	laboratoryWaterSamplingRegulatoryDocumentId: number;
	laboratoryWaterSamplingRegulatoryDocumentIds: number[] = [];
	laboratoryWaterSamplingRegulatoryDocumentDescription: string;
	laboratoryWaterSamplingConditionId: number;
	laboratoryWaterSamplingConditionDescription: string;
	expressExamination: boolean;

	useCustomerAddressFromCustomer: boolean;
	useSampleNameFromCustomer: boolean;
	useSamplingAddressFromCustomer: boolean;
	useLaboratoryMaterialSourceFromCustomer: boolean;
	useLaboratorySamplingPointFromCustomer: boolean;
	useLaboratorySpecialMarksFromCustomer: boolean;
	useLaboratorySamplingDateTimeFromCustomer: boolean;

	customerContact: RequestWaterSamplingContact = new RequestWaterSamplingContact();
	customerAddress: RequestWaterSamplingAddress = new RequestWaterSamplingAddress();
	samplingAddress: RequestWaterSamplingAddress = new RequestWaterSamplingAddress();
    requestIndicators: LaboratoryRequestIndicatorDto[] = [];
	laboratoryWaterSamples: LaboratoryWaterSampleDto[] = [];
}